/**
 * Live chat and history message APIs.
 */
import {
  fetchGetCustomerMessagesById,
  fetchGetInteractedCustomerdetailsCountByPhoneNoId,
  fetchGetInteractedCustomersByBusinessIdByPhoneNoId,
  fetchGetInteractedinactivecustomerByPhoneNoId,
  fetchUpdatecustomerreadByCustomerId,
  postChangestatus,
} from "./customer.api";
import { postSendTextonly } from "./messaging.api";
import { apihubGet } from "./apihub";

function normalizeAttributeName(value) {
  if (value == null) return "";
  if (typeof value === "string") return value.trim();
  return String(value.name || value.attribute_name || value.key || "").trim();
}

export async function fetchProjectAttributeNames({ phoneNoId, projectId } = {}) {
  const ids = [phoneNoId, projectId].filter(Boolean);
  for (const id of ids) {
    try {
      const res = await apihubGet(
        `/getInteractedCustomerDetail/getattributesdetail/${id}`
      );
      const attrs = res?.data?.attributes || res?.attributes || [];
      const names = (Array.isArray(attrs) ? attrs : [])
        .map(normalizeAttributeName)
        .filter(Boolean);
      if (names.length) return [...new Set(names)];
    } catch {
      /* try the next id */
    }
  }
  return [];
}

export async function fetchCannedMessagesByProject(projectId) {
  if (!projectId) return [];
  const res = await apihubGet(
    `/getInteractedCustomerDetail/fetchcannedmessage/${projectId}`
  );
  const rows = Array.isArray(res?.data) ? res.data : [];
  return rows
    .map((row) => ({
      id: row.id || row._id,
      name: row.name || "Quick reply",
      text: String(row.text || row.message_text || "").trim(),
      favourite: Boolean(row.isFavourite || row.is_favourite),
    }))
    .filter((row) => row.text);
}

export function fetchInactiveContacts(
  phoneNoId,
  { page = 1, limit = 10, search = "" } = {},
) {
  return fetchGetInteractedinactivecustomerByPhoneNoId(
    { phoneNoId },
    { page, limit, search },
  );
}

export function fetchCustomerMessages(customerId, { limit = 100, skip = 0 } = {}) {
  return fetchGetCustomerMessagesById({ id: customerId }, { limit, skip });
}

export function markCustomerRead(customerId) {
  return fetchUpdatecustomerreadByCustomerId({ customerId });
}

export async function fetchCustomerThread(customerId, options) {
  const res = await fetchCustomerMessages(customerId, options);
  if (customerId) {
    try {
      await markCustomerRead(customerId);
    } catch {
      /* non-fatal */
    }
  }
  return res;
}

export function fetchLiveChatContacts(phoneNoId) {
  return Promise.all([
    fetchGetInteractedCustomersByBusinessIdByPhoneNoId({ phoneNoId }),
    fetchGetInteractedCustomerdetailsCountByPhoneNoId({ phoneNoId }),
  ]);
}

export { postChangestatus as changeChatStatus, postSendTextonly as sendTextMessage };
